<svg xmlns="http://www.w3.org/2000/svg" [attr.class]="icon()">
  <use [attr.href]="'#' + icon()"></use>
</svg>
